export default __webpack_public_path__ + "static/media/BTS.ce7c28e6.png";